/* eslint-disable radix */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-curly-brace-presence */
/* eslint-disable react/jsx-no-bind */

import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useHistory } from 'react-router-dom';
import {
  Button,
  Input,
  InputGroup,
  SelectPicker,
  Table,
  IconButton,
  Toggle,
  Loader,
} from 'rsuite';
import { MdAdd, MdEdit, MdDelete, MdVisibility } from 'react-icons/md';
import { toast } from 'react-toastify';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

import {
  Container2,
  Header,
  FiltersRow,
  CardTreinamento,
  CardInfo,
  CardActions,
  EmptyState,
  ContainerCards
} from './styles';
import StatusBadge from './components/StatusBadge';
import ConfirmDialog from './components/ConfirmDialog';
import {
  getTreinamentos,
  deleteTreinamento,
  toggleTreinamentoAtivo,
} from '../../services/treinamentos';
import SearchInputTable from '../../components/SearchInputTable';
import EditarTreinamento from './EditarTreinamento';
import Card from '../../components/Card';

const { Column, HeaderCell, Cell } = Table;

const statusOptions = [
  { label: 'Todos', value: null },
  { label: 'Ativos', value: 'true' },
  { label: 'Inativos', value: 'false' },
];

function ListaTreinamentos() {
  // const navigate = useNavigate();
   const history = useHistory();
  const [treinamentos, setTreinamentos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pagina, setPagina] = useState(1);
  const [_total, setTotal] = useState(0);
  const [totalPaginas, setTotalPaginas] = useState(1);
  const [filtroStatus, setFiltroStatus] = useState(null);
  const [deleteModal, setDeleteModal] = useState({ open: false, id: null, titulo: '' });
  const [deleting, setDeleting] = useState(false);
  const [toggling, setToggling] = useState(null);
  const [textodigitado, setTextoDigitado] = useState();
  const [showEditarTreinamento, setShowEditarTreinamento] =
        useState(false);
  const [treinamentoEditando, setTreinamentoEditando] = useState();
  

  const loadTreinamentos = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getTreinamentos(pagina, filtroStatus, textodigitado);
      if (data.treinamentos.length === 0 && pagina > 1) {
        setPagina(1);
      }
      setTreinamentos(data.treinamentos || []);
      setTotal(data.total || 0);
      setTotalPaginas(data.paginas || 1);
    } catch (error) {
      toast.error('Erro ao carregar treinamentos');
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [pagina, filtroStatus, textodigitado]);

  useEffect(() => {
    loadTreinamentos();
  }, [loadTreinamentos]);


  const handleToggleAtivo = useCallback(async (id) => {
    setToggling(id);
    try {
      const result = await toggleTreinamentoAtivo(id);
      toast.success(result.message);
      loadTreinamentos();
    } catch {
      toast.error('Erro ao alterar status');
    } finally {
      setToggling(null);
    }
  }, [loadTreinamentos]);

  const handleDelete = useCallback(async () => {
    if (!deleteModal.id) return;

    setDeleting(true);
    try {
      await deleteTreinamento(deleteModal.id);
      toast.success('Treinamento excluído com sucesso');
      setDeleteModal({ open: false, id: null, titulo: '' });
      loadTreinamentos();
    } catch (error) {
      toast.error(error.message || 'Erro ao excluir treinamento');
    } finally {
      setDeleting(false);
    }
  }, [deleteModal.id, loadTreinamentos]);

  const handleEdit = ((treinamento) => {
    setShowEditarTreinamento(true);
    setTreinamentoEditando(treinamento);
  });

  const handleCreate = useCallback(() => {
    setShowEditarTreinamento(true)
  }, [history]);

  function abrirEditarTreinamento(treinamento) {
    setTreinamentoEditando(treinamento);
    setShowEditarTreinamento(true);
  }

  function fecharEditarTreinamento() {
    loadTreinamentos();
    setShowEditarTreinamento(false);
    setTreinamentoEditando(null);
  }

  return (
    <Container2>
      <Header>
        <h1>Treinamentos</h1>
        <Button appearance="primary" onClick={handleCreate}>
          <MdAdd style={{ marginRight: 8 }} />
          Novo Treinamento
        </Button>
      </Header>

    <Card>
      <FiltersRow>
        <SearchInputTable
        place='Buscar por título...'
                  estilo={{ marginRight: '0px', width: '300px' }}
                  setTextoDigitado={setTextoDigitado} />

        <SelectPicker
          data={statusOptions}
          value={filtroStatus}
          onChange={setFiltroStatus}
          placeholder="Status"
          searchable={false}
          cleanable={false}
          style={{ width: 150 }}
        />
      </FiltersRow>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <Loader size="lg" content="Carregando treinamentos..." />
        </div>
      ) : treinamentos.length === 0 ? (
        <EmptyState>
          <MdVisibility />
          <h3>Nenhum treinamento encontrado</h3>
          <p>Crie seu primeiro treinamento para começar</p>
          <Button appearance="primary" onClick={handleCreate}>
            <MdAdd style={{ marginRight: 8 }} />
            Criar Treinamento
          </Button>
        </EmptyState>
      ) : (
        <>
            <ContainerCards>
          {treinamentos.map((treinamento) => (
            <CardTreinamento
              key={treinamento.id}
              onClick={() => {
                setTreinamentoEditando(treinamento);
                setShowEditarTreinamento(true);
              }
              }
            >
              <CardInfo>
                <h3 className="title">{treinamento.titulo}</h3>
                <div className="slug">{treinamento.slug}</div>
                <div className="meta">
                  <span>{treinamento.modulos?.length || 0} módulo(s)</span>
                  <span>
                    Criado em{' '}
                    {treinamento.createdAt
                      ? format(new Date(treinamento.createdAt), 'dd/MM/yyyy', { locale: ptBR })
                      : '-'}
                  </span>
                </div>
              </CardInfo>

              <CardActions onClick={(e) => e.stopPropagation()}>
                <StatusBadge variant={treinamento.ativo ? 'ativo' : 'inativo'}>
                  {treinamento.ativo ? 'Ativo' : 'Inativo'}
                </StatusBadge>

                <Toggle
                  checked={treinamento.ativo}
                  loading={toggling === treinamento.id}
                  onChange={() => handleToggleAtivo(treinamento.id)}
                />

                <IconButton
                  icon={<MdEdit />}
                  appearance="subtle"
                  onClick={() => handleEdit(treinamento)}
                  // onClick={() => handleEdit(treinamento.id)}
                />

                <IconButton
                  icon={<MdDelete />}
                  appearance="subtle"
                  color="red"
                  onClick={() =>
                    setDeleteModal({
                      open: true,
                      id: treinamento.id,
                      titulo: treinamento.titulo,
                    })
                  }
                />
              </CardActions>
            </CardTreinamento>
          ))}
          </ContainerCards>
          

          {/* Paginação simples */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 20 }}>
            <Button
              disabled={pagina <= 1}
              onClick={() => setPagina((p) => p - 1)}
            >
              Anterior
            </Button>
            <span style={{ padding: '8px 16px' }}>
              Página {pagina} de {totalPaginas}
            </span>
            <Button
              disabled={pagina >= totalPaginas}
              onClick={() => setPagina((p) => p + 1)}
            >
              Próxima
            </Button>
          </div>
        </>
      )}
      </Card>

      <ConfirmDialog
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, id: null, titulo: '' })}
        onConfirm={handleDelete}
        title="Excluir Treinamento"
        message={`Tem certeza que deseja excluir o treinamento "${deleteModal.titulo}"? Esta ação não pode ser desfeita.`}
        confirmText="Excluir"
        loading={deleting}
      />
      <EditarTreinamento
        showEditarTreinamento={showEditarTreinamento}
        setShowEditarTreinamento={setShowEditarTreinamento}
        // onClose={() => setShowEditarTreinamento(false)}
        idTreinamento={treinamentoEditando && treinamentoEditando?.id}
        fecharEditarTreinamento={fecharEditarTreinamento}
      />
    </Container2>
  );
}

export default ListaTreinamentos;
